<template>
<section class="pr-section _preview-section" v-if="$store.state.register.form.top_news.length > 0">
    <div class="section-inner">

        <div class="item ">
            <h2>{{$store.state.register.form.top_news}}</h2>
        </div>

    </div>
</section>
</template>
